module.exports = __webpack_public_path__ + "static/media/d4.fc0d86bd.png";